export enum GoldenRockCustomLayers {
  MENUS_BACKGROUND = "MenusBackground",
  ONBOARD_BLOCKER = "OnboardBlocker"
}
